import { defineStyleConfig } from '@chakra-ui/react';

const Input = defineStyleConfig({
  variants: {
    outline: (props) => ({
      field: {
        bg: props.colorMode === 'dark' ? 'surface.darkContent' : 'surface.content',
        color: props.colorMode === 'dark' ? '#F9FAFB' : 'ink.primary',
        borderColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
        _placeholder: {
          color: props.colorMode === 'dark' ? 'ink.secondary' : 'ink.secondary',
        },
        _hover: {
          borderColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.500',
        },
        _focusVisible: {
          borderColor: 'brand.blue.500',
          boxShadow: 'focus',
        },
      },
    }),
  },
  defaultProps: {
    variant: 'outline',
  },
});

export default Input;